import React, { useMemo, useState } from 'react';
import './styles.less';
import classNames from 'classnames';
import { getString } from '@nackle/intl-tools';
import { Button, Form, Input, PaperIcon, Rate } from '@nackle/paper';
import { Spin } from 'antd';
import { submitCourseRating } from '../../../gql';

const ERROR_KEYS = {
    NO_RATING: 'error.rating.noRating',
    NO_COMMENT: 'error.rating.noRatingDescription',
    LONG_COMMENT: 'page.courseDetails.sections.ratings.actions.comments.error.maxLength',
    IS_RATED: 'error.rating.isRated',
};

export const RatingSection = ( { isRated, rating, review, itemId, onSubmitCb, onCloseFormCb } ) => {

    const [ form ] = Form.useForm();

    const [ submitting, setSubmitting ] = useState( false );
    const [ submittable, setSubmittable ] = useState( false );

    const formDisabled = useMemo( () => submitting || isRated, [ submitting, isRated ] );
  
    const handleFormChange = () => {
        const hasErrors = form.getFieldsError().some( ( { errors } ) => errors.length )
            || form.getFieldValue( 'stars' ) == null;
        setSubmittable( !hasErrors && !isRated && !submitting );
    };

    async function submitRating( comment, stars ) {
        const response = await submitCourseRating( itemId, stars, comment );
        if ( response ) {
            onSubmitCb?.( { comment, stars } );
            setSubmitting( false );
        }
    }

    const handleSubmitRating = ( { comment, stars } ) => {
        if ( submitting === true || isRated === true ) {return;}

        setSubmitting( true );
        setSubmittable( false );

        submitRating( comment, stars );
    };

    return (
        <>
            <Button  className={ classNames( 'primary', 'action-button', '_mini' ) } >
                { getString( 'page.courseDetails.sections.ratings.body.description' ) }
            </Button>
            <div className={ classNames( 'rate', 'shaded', 'noselect' ) }>
                <div className='header'>
                    <h3>{ getString( 'page.courseDetails.sections.ratings.header' ) } </h3> 
                    <button className='close' onClick={ () => onCloseFormCb?.() }>
                        <PaperIcon icon='Close' collection='antd-outlined' />
                    </button> 
                </div>
                <Form
                    name='rate'
                    role='table'
                    form={ form }
                    layout={ 'vertical' }
                    initialValues={ {
                        stars: rating ?? null,
                        comment: review ?? '',
                    } }
                    requiredMark={ false }
                    colon={ false }
                    disabled={ formDisabled }
                    onFinish={ handleSubmitRating }
                    onValuesChange={ handleFormChange }
                    autoComplete='off'>
                        

                    <Form.Item
                        className='rate-comment'
                        name='comment'
                        disabled={ formDisabled }
                        rules={ [
                            { required: true, message: null },
                            { max: 264, message: getString( ERROR_KEYS.LONG_COMMENT ) }
                        ] }
                        >
                        <Input.TextArea disabled={ isRated } rows={ 4 } 
                            placeholder={ getString( 'page.courseDetails.sections.ratings.actions.comments.label' ) }
                            />

                    </Form.Item>
                    <Form.Item
                        className='rate-stars'
                        name='stars'
                        rules={ [
                            { required: true, message: null }
                        ] }
                        >
                        
                        <Rate
                            className="course-rating"
                            disabled={ formDisabled }
                            allowClear={ false }
                        />
                    </Form.Item>
                    <Form.Item
                        className='submit'
                        name='submit'>
                        <Button htmlType='submit' 
                            className={ classNames( 'action-button', 'primary', '_mini' ) } 
                            disabled={ !submittable }
                            >
                            { submitting ? <Spin /> : getString( 'page.courseDetails.sections.ratings.actions.submit' ) }
                        </Button>
                    </Form.Item>
                </Form>
            </div>
                    
            
        
        </>
    );
};